/** Last explicitly chosen provider/model, shared by all new conversations. */
export interface ModelPreference {
  providerId: string;
  model: string;
  modelKind?: 'text' | 'image';
}

const STORAGE_KEY = 'zxtalk.modelPreference.v1';

function storage(): Storage | undefined {
  try {
    return typeof globalThis.localStorage === 'undefined' ? undefined : globalThis.localStorage;
  } catch {
    return undefined;
  }
}

export function loadModelPreference(): ModelPreference | null {
  const raw = storage()?.getItem(STORAGE_KEY);
  if (raw === null || raw === undefined) return null;
  try {
    const value = JSON.parse(raw) as Partial<ModelPreference>;
    return typeof value.providerId === 'string' && value.providerId.trim() !== '' &&
      typeof value.model === 'string' && value.model.trim() !== ''
      ? {
          providerId: value.providerId,
          model: value.model,
          ...(value.modelKind === 'image' ? { modelKind: 'image' as const } : {}),
        }
      : null;
  } catch {
    return null;
  }
}

export function saveModelPreference(
  providerId: string,
  model: string,
  modelKind: 'text' | 'image' = 'text',
): void {
  if (providerId.trim() === '' || model.trim() === '') return;
  storage()?.setItem(STORAGE_KEY, JSON.stringify({ providerId, model, ...(modelKind === 'image' ? { modelKind } : {}) }));
}

export function clearModelPreference(): void {
  storage()?.removeItem(STORAGE_KEY);
}
